import {SureFlowRatingCircuitResponse} from './sure-flow-rating-circuit-response';
import {SureFlowRatingCoilResponse} from './sure-flow-rating-coil-response';

export class SureFlowRatingUnitResponse {

  id!: number;
  airflow!: number;
  circuitResponse!: SureFlowRatingCircuitResponse;
  alternateCircuit!: SureFlowRatingCircuitResponse;
  primaryCoilResponse!: SureFlowRatingCoilResponse;
  secondaryCoilResponse!: SureFlowRatingCoilResponse;
  electricHeatResponse!: SureFlowRatingCoilResponse;
  errorMessage!: string;

}
